/** Local calendar month as YYYY-MM (matches server `parseCalcMonthQuery` default). */
export function currentYYYYMM(d = new Date()) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function addMonthsYYYYMM(ym, delta) {
  const [y, m] = ym.split('-').map(Number);
  if (!Number.isFinite(y) || !Number.isFinite(m)) return currentYYYYMM();
  const nd = new Date(y, m - 1 + delta, 1);
  return `${nd.getFullYear()}-${String(nd.getMonth() + 1).padStart(2, '0')}`;
}

export function formatYYYYMMLong(ym) {
  const [y, mo] = ym.split('-').map(Number);
  if (!Number.isFinite(y) || !Number.isFinite(mo)) return '';
  return new Date(y, mo - 1, 1).toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });
}

export function formatYYYYMMShort(ym) {
  const [y, mo] = ym.split('-').map(Number);
  if (!Number.isFinite(y) || !Number.isFinite(mo)) return '';
  return new Date(y, mo - 1, 1).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
}

/** First / last local calendar day as YYYY-MM-DD for operations `startDate` / `endDate`. */
export function localMonthDateRangeStrings(yyyyMm) {
  const [y, m] = yyyyMm.split('-').map(Number);
  if (!Number.isFinite(y) || !Number.isFinite(m)) {
    const d = new Date();
    return localMonthDateRangeStrings(currentYYYYMM(d));
  }
  const start = new Date(y, m - 1, 1);
  const end = new Date(y, m, 0);
  const pad = (n) => String(n).padStart(2, '0');
  return {
    startStr: `${start.getFullYear()}-${pad(start.getMonth() + 1)}-${pad(start.getDate())}`,
    endStr: `${end.getFullYear()}-${pad(end.getMonth() + 1)}-${pad(end.getDate())}`,
  };
}

export function chartYearMonthBounds(hoursChart) {
  const yms = (Array.isArray(hoursChart) ? hoursChart : [])
    .map((r) => hoursChartRowYYYYMM(r))
    .filter(Boolean)
    .sort();
  if (!yms.length) return null;
  return { min: yms[0], max: yms[yms.length - 1] };
}

/** Resolve a chart row to YYYY-MM (API `yearMonth` or parsed `month` label). */
export function hoursChartRowYYYYMM(row) {
  if (row?.yearMonth && /^\d{4}-\d{2}$/.test(String(row.yearMonth))) {
    return String(row.yearMonth);
  }
  const label = row?.month ?? row?.label ?? '';
  if (!label) return null;
  const parsed = Date.parse(`1 ${label}`);
  if (!Number.isNaN(parsed)) {
    return currentYYYYMM(new Date(parsed));
  }
  return null;
}

/** Find chart row for a YYYY-MM month key. */
export function findHoursChartRow(hoursChart, yyyyMm) {
  if (!yyyyMm || !Array.isArray(hoursChart)) return null;
  return hoursChart.find((r) => hoursChartRowYYYYMM(r) === yyyyMm) ?? null;
}

export function monthLabelToYYYYMM(label, hoursChart) {
  if (!label) return null;
  const row = (Array.isArray(hoursChart) ? hoursChart : []).find((r) => r?.month === label);
  return hoursChartRowYYYYMM(row);
}
